module.exports = __webpack_public_path__ + "static/media/22.1bb647e4.jpg";